import React from "react";
import { Box, Typography } from "@mui/material";

const FAKE_HEIGHTS_PCT = [38, 72, 45, 88, 52, 67, 41, 76, 48, 63];

const ChartEmptyState = ({ minHeight = 200 }) => (
  <Box
    sx={{
      position: "relative",
      minHeight,
      borderRadius: "12px",
      overflow: "hidden",
      backgroundColor: "#f1f5f9",
      border: "1px solid rgba(15, 23, 42, 0.06)",
    }}
  >
    <Box
      sx={{
        filter: "blur(7px)",
        opacity: 0.5,
        px: 2,
        py: 2,
        height: Math.max(minHeight - 16, 160),
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "stretch",
        gap: 0.75,
        boxSizing: "border-box",
      }}
    >
      {FAKE_HEIGHTS_PCT.map((pct, i) => (
        <Box
          key={i}
          sx={{
            flex: 1,
            minWidth: 0,
            height: `${pct}%`,
            backgroundColor: "#94a3b8",
            borderRadius: "4px",
          }}
        />
      ))}
    </Box>
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: "none",
        px: 2,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Rubik",
          fontWeight: 600,
          fontSize: { xs: 14, sm: 15 },
          color: "#0f172a",
          textAlign: "center",
          lineHeight: 1.45,
          textShadow: "0 0 12px rgba(255,255,255,0.95), 0 0 20px rgba(255,255,255,0.8)",
        }}
      >
        Non abbiamo ancora abbastanza dati 🫤
      </Typography>
    </Box>
  </Box>
);

export default ChartEmptyState;
